// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__15nZQ","title":"Header_title__3Qj4W","side":"Header_side__3CKMB"};